module.exports = __webpack_public_path__ + "static/media/logo.3ac57729.svg";